import {
  Required,
  IsString,
  DataValidator,
  transformKeys,
  IsNumber,
} from "@/utils/type-vaildator";
import api from "./api";

// 原始接口
export interface AgentV2TemplateDetailResponse {
  uuid: string;
  cover_url: string;
  cover_video: string;
  style_model_id: string;
  actor_model_id: string;
  voice_model_id: string;
  actor_pic_url: string;
  actor_name: string;
  template_name: string;
  voice_sample_url: string;
  voice_name: string;
};

export class AgentV2TemplateDetailData {
  @Required("UUID cannot be empty")
  @IsString("UUID must be a string")
  uuid: string;

  @Required("Cover URL cannot be empty")
  @IsString("Cover URL must be a string")
  coverUrl: string;

  // @Required("Cover video cannot be empty")
  @IsString("Cover video must be a string")
  coverVideo: string;

  @Required("Template name cannot be empty")
  @IsString("Template name must be a string")
  templateName: string;

  @Required("Style model ID cannot be empty")
  @IsString("Style model ID must be a string")
  styleModelId: string;

  // @Required("Actor model ID cannot be empty")
  @IsString("Actor model ID must be a string")
  actorModelId: string;

  // @Required("Voice model ID cannot be empty")
  @IsString("Voice model ID must be a string")
  voiceModelId: string;

  // @Required("Actor pic URL cannot be empty")
  @IsString("Actor pic URL must be a string")
  actorPicUrl: string;

  // @Required("Actor name cannot be empty")
  @IsString("Actor name must be a string")
  actorName: string;

  // @Required("Voice sample URL cannot be empty")
  @IsString("Voice sample URL must be a string")
  voiceSampleUrl: string;

  // @Required("Voice name cannot be empty")
  @IsString("Voice name must be a string")
  voiceName: string;

  // @Required("Speed ratio cannot be empty")
  @IsNumber("Speed ratio must be a number")
  speedRatio: number;

  @IsString("Scene must be a string")
  scene: string;
}

const transformAndValidateAgent = (
  response: AgentV2TemplateDetailResponse
): AgentV2TemplateDetailData => {
  const transformedData = transformKeys(response);
  
  try {
    return DataValidator.validateOrThrow(transformedData, AgentV2TemplateDetailData);
  } catch (error) {
    console.error("Agent V2 Template data validation failed:", error.message);
    throw error;
  }
};

/** 获取 Agent 模板详情 */
export const agentV2TemplateDetail = async ({ uuid }: { uuid: string }): Promise<AgentV2TemplateDetailData> => {
  const response = await api.post<AgentV2TemplateDetailResponse>('/agent-v2/template-detail', {
    uuid,
  });
  const data = transformAndValidateAgent(response.data);
  return data;
};
